export const Attendance = {
  attStatusNames: new Map([
    ['attended', '수업'],
    ['absent', '결석'],
    ['late', '지각'],
    ['present', '등원'],
    ['left', '하원'],
    ['custom', '기타'],
  ]),
  attStatusColorKeys: {
    attended: 'info.main',
    absent: 'error.main',
    late: 'warning.main',
    present: 'success.light',
    left: 'trivialAction.main',
    clockIn: 'teacherClockInOut.light',
    clockOut: 'teacherClockInOut.dark',
  },
  attStatusNamesForTeacher: new Map([
    ['clockIn', '출근'],
    ['clockOut', '퇴근'],
  ]),
  attNotificationMethodNames: new Map([
    ['push', '항상 앱알림'],
    ['alimTalkToNonMember', '미가입 학부모에게는 알림톡'],
    ['alimTalkToAll', '항상 알림톡'],
  ]),
  attCodeBaseNames: new Map([
    ['parentPhone', '학부모 전화번호 뒷 4자리'],
    ['studentPhone', '학생 전화번호 뒷 4자리'],
  ]),
  dayLabelsFromMon: new Map([
    [1, '월'],
    [2, '화'],
    [3, '수'],
    [4, '목'],
    [5, '금'],
    [6, '토'],
    [0, '일'],
  ]),
  attRealtimeStatusNames: new Map([
    ['waiting', '대기중'],
    ['called', '부르는중'],
    ['attending', '수업중'],
    ['dismissed', '수업완료'],
    ['left', '하원함'],
  ]),
  attRealtimeStatusChangeActionNames: new Map([
    ['waiting_called', '부르기'],
    ['waiting_attending', '수업시작'],

    ['called_waiting', '부르기 취소'],
    ['called_called', '다시 부르기'],
    ['called_attending', '수업시작'],

    ['attending_waiting', '수업취소'],
    ['attending_dismissed', '수업종료'],

    ['dismissed_waiting', '완료취소'],
  ]),
  dayNamesKor: ['일', '월', '화', '수', '목', '금', '토'],
};
